export default "__VITE_ASSET__ChLhk7XA__"